import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import {OnFailureData, OnSuccess} from "../../../../store/action/actionHelpers";
import SingleFileSelector from "../../../file/SingleFileSelector";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {uploadAssets} from "../../../../store/action/asset/asset";
import Toast from "../../../helper/Toast";
import {none, Option, option} from "ts-option";
import {ImportResult} from "../../../../model/importResult/ImportResult";


interface IComponentProps {
	/**
	 * On modal close.
	 */
	onClose: () => void;
	/**
	 * Asset attribute header
	 */
	assetAttributeHeader?: Option<string>;
}

interface IDispatchProps {
	/**
	 * Upload assets from xlsx file.
	 * @param {File} file
	 * @param {string} assetAttributeHeader
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailureData<ImportResult>} onFailure
	 */
	uploadAssets: (file: File,
		assetAttributeHeader: string,
		onSuccess: OnSuccess,
		onFailure: OnFailureData<Option<ImportResult>>) => void;
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

type Props = IComponentProps & IDispatchProps;

class UploadAssetModal extends React.Component<Props, IState> {
	public static defaultProps: Partial<Props> = {
		assetAttributeHeader: none
	};

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Upload asset"}>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onClose}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}/>
			</Modal>
		);
	}

	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				this.props.uploadAssets(file, this.props.assetAttributeHeader.orNull,
					() => {
						Toast.success("Assets uploaded successfully.", "Assets upload");
						this.setState({filesUploading: false});
						this.props.onClose();
					},
					(result: Option<ImportResult>) => {
						const errors = result.map(e => e.error).getOrElse([]);
						this.setState({errors: errors, filesUploading: false});
						Toast.error("Cannot upload assets.", "Assets upload");
					});
			});
		}
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		uploadAssets: (file: File,
			assetAttributeHeader: string,
			onSuccess: OnSuccess,
			onFailure: OnFailureData<Option<ImportResult>>) => dispatch(
			uploadAssets(file, assetAttributeHeader, onSuccess, onFailure))
	}
}

export default connect(null, mapDispatchToProps)(UploadAssetModal);
